import React, { useRef, useEffect, useState } from 'react';

// 支持千分位和小数点的数字滚动动画
export default function AnimatedNumber({ value, duration = 500, className = '', prefix = '', ...rest }) {
  const [display, setDisplay] = useState(value);
  const rafRef = useRef();
  const prevValue = useRef(value);
  
  useEffect(() => {
    if (prevValue.current === value) return;
    const start = prevValue.current;
    const end = value;
    const startTime = performance.now();
    function animate(now) {
      const elapsed = Math.min((now - startTime) / duration, 1);
      const current = start + (end - start) * ease(elapsed);
      setDisplay(current);
      if (elapsed < 1) {
        rafRef.current = requestAnimationFrame(animate);
      } else {
        setDisplay(end);
        prevValue.current = value;
      }
    }
    cancelAnimationFrame(rafRef.current);
    rafRef.current = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(rafRef.current);
  }, [value, duration]);

  function ease(t) {
    // easeOutCubic
    return 1 - Math.pow(1 - t, 3);
  }

  // 保留小数点后两位，带千分位
  function format(num) {
    if (typeof num !== 'number') return '';
    return num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  return (
    <span className={className} {...rest}>
      {prefix}{format(display)}
    </span>
  );
}
